import { Component, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MatSelect } from '@angular/material';
import { HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';


import { TranslateService } from '../../../../../../services/translate.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material/material';
import { BootstrapI18nService } from '../../../../../../i18n/bootstrap/bootstrap-i18n.service';
import * as moment from 'moment';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { UserService } from '../../../../../../services/user.service';
import { WksCentralService } from '../../../../services/wks-central.service';
import { WksBusinessModel } from '../../../../models/wks-business.model';
import { WksApisService } from '../../../../services/wks-apis.service';
import { WksGedDocumentService } from '../../../../services/wks-ged-document.service';
import { WksMistralOcrService } from '../../../../services/wks-mistral-ocr.service';
import { RemoteFilesService } from '../../../../../common/services/remote-files.service';

import { InternationalsFormats, LabelValue } from '../../../../../../models/data.model';
import { RessourcesService } from '../../../../../../job/common/services/ressources.service';
import { WksEntityModel } from '../../../../models/wks-entity.model';
import { PartsStock, WksGedDocument, WksPartsDelivery, WksPartsDeliveryDetail, WorkInputEvent } from '../../../../models/wks-works.model';

import { ModalCommonComponent } from '../../../../../common/components/modal-common/modal-common.component';
import { GedScannerComponent } from '../../../others/ged-scanner/ged-scanner.component';
import { CommonMethods } from '../../../../../../job/common/tools/commonMethods';
import { EntityOCR, MessageDisplay, ToolApiResponse, ToolArgs, ToolKeyValue } from '../../../../../../models/common.model';

import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { BnsCardSheetsComponent } from '../../../repositories/bns/bns-card-sheets/bns-card-sheets.component';
import { PartsSuppliesCardComponent } from '../../../param/parts-supplies/parts-supplies-card/parts-supplies-card.component';
import { BarCode, ParamPartsSuppliesModel } from '../../../../models/wks-param.model';
// Difficultés liées au scanner la capture est incorrecte
// import { BarcodeScannerService } from '../../../../../../job/common/services/barcode-scanner.service'; 
import {
  SupplierInvoiceChangeStatusComponent
} from '../../supplier-invoices/supplier-invoice-change-statut/supplier-invoice-change-statut.component';

export interface OcrBonLivraison {
    numero_bl: string;
    date_livraison: string;
    lignes: OcrLigneBonLivraison[];
    total_ht: string;
    total_tva: string;
    total_ttc: string;
}

export interface OcrLigneBonLivraison {
    reference: string;
    designation: string;
    quantite: string;
    pu_brut: string;
    remise: string;
    pu_net: string;
    pt_ht: string;
}

interface RowPart {
    barcode: string;
    brandRef: string;
    brandLabel: string;
    partQty: number;
    supplierPackaging: number;
    partPurchase: number;
    coef: number;
    partSelling: number;
    partStatut: string;
    stockId: string;
    partsSupplies: ParamPartsSuppliesModel;
    isCollapsed: boolean;
    odd: boolean;
    toCreate: boolean;
    isFound: boolean;
  }

@Component({
  selector: 'mdi-stocks-parts-delivery',
  templateUrl: './stocks-parts-delivery.component.html',
  styleUrls: ['./stocks-parts-delivery.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class StocksPartsDeliveryComponent implements OnInit {
  
  private readonly onDestroy = new Subject<void>();
  wksEntity: WksEntityModel;
  
  initializeScreen: boolean;
  doRegister: boolean;
  inputInProgress: boolean;
  readOnlyData: boolean;
  createSupplier: boolean;

  numberFormat: {
    locale: string;
    minDecimal: string;
    maxDecimal: string;
    currency: string;
  };
  internationalsFormats: InternationalsFormats;
  dateFormat: string;
  dateFormatMoment: string;
  dateTimeFormat: string;
  dataLabelCur: string[];
  timeFormat: string;
  tabSelected: number;
  
  minDate: Date;
  maxDate: Date;

  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth();
  day = this.now.getDate();

  minDayDate: Date;
  maxDayDate: Date;
  currentDateValue: Date[] = [];
  defaultDateRef: Date;

  addingDelivery: boolean;
  updateDelivery: boolean;
  videoCodingDelivery: boolean;
  gedDocumentVideoCoding: WksGedDocument | undefined;

  partDeliveryForm: FormGroup;
  entityCur: string;
  titleCard: string;

  partDeliveryCache: string;
  suppliersList: WksBusinessModel[];
  suppliersSelection: WksBusinessModel[];
  supplierCur: WksBusinessModel;

  wareHousesList: {
    warehouseId: string;
    warehouseRef: string;
  }[];
  warehouseIdCur: string;
  bsnCur: string;
  bsnSelected: string;
  bsnSearch: boolean;
  // deliveryDate: string;
  deliveryDate: Date | undefined = undefined;
  showGedWaiting = false;
  rowsParts: {
    barcode: string;
    brandRef: string;
    brandLabel: string;
    partQty: number;
    partStatut: string;
    stockId: string;
    supplierPackaging: number;
    partPurchase: number;
    coef: number;
    partSelling: number;
    partsSupplies: ParamPartsSuppliesModel;
    isCollapsed: boolean;
    toCreate: boolean;
    isFound: boolean;
  }[];
  rowsDeliveries: {
    isCollapsed: boolean;
    isSelected: boolean;
    toUpdate: boolean;
  }[];
  rowsPartsForm: FormGroup;
  fieldFormat: {
    locale: string;
    minDecimal: string;
    maxDecimal: string;
    currency: string;
    justifCurrency: string;
    justifText: string;
    justifNumbers: string;
    language: string;
  };
  datePickerConfig: Partial<BsDatepickerConfig>;
  showAlert: boolean;
  alertMessage: string;
  partsDeliveryRead: WksPartsDelivery;

  loadingIndicator = true;
  partsDeliveriesList: WksPartsDelivery[];
  partsDeliveriesDetailList: WksPartsDeliveryDetail[];
  datasDeliveryDetail: {    
    brandLabel: string;
    movementId: string;
  }[];
 
  gedDocumentsWaiting: WksGedDocument[] = [];
  gedDocumentImageVisible = false;
  gedDocumentImage: WksGedDocument | undefined;  
  gedDocumentImageBlob: Blob;
  gedDocumentImageUrl: string | undefined;
  gedDocumentImageSafeUrl: SafeUrl | undefined;
  gedDocumentImageZoom = 1;
  gedDocumentImageLoading = false;
  videoCodingProcessing = false;
  idxSelected: number;
  scanCodeActivate: boolean;
  MIN_CAR = 4;

  barcode = '';
  lastEventTime = 0;
  timeout: any;
  SCAN_THRESHOLD = 20; // ms max entre 2 touches (scanner rapide)

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {

    // console.log('keydown reçu', event.key);

    if (event.key === undefined) {
      return;
    }

    const now = Date.now();

    // Si trop lent → reset (probablement humain)
    if (now - this.lastEventTime > this.SCAN_THRESHOLD) {
      this.barcode = '';
    }

    // Évite les interférences avec les champs de saisie
    const isFast = now - this.lastEventTime <= this.SCAN_THRESHOLD;
    if (isFast) {
      event.preventDefault();
    }

    this.lastEventTime = now;

    // Ignore certaines touches
    if (event.key.length === 1) {
      this.barcode += event.key;
    }

    // Reset du timer de fin de scan
    clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      if (this.barcode.length > 3) {
        // console.log('Code scanné :', this.barcode);
        this.appliJob();
      }
      this.barcode = '';
    }, 100);
  }

  constructor(private fb: FormBuilder,
                private overlay: Overlay,
                private _userService: UserService,
                private _translateService: TranslateService,
                private _wksCentralService: WksCentralService,
                private _ressourcesService: RessourcesService,
                private _dialog: MatDialog,
                private _bsI18nService: BootstrapI18nService,
                private router: Router,
                private wksApisService: WksApisService,
                private wksGedDocumentService: WksGedDocumentService,
                private sanitizer: DomSanitizer,
                private mistralOcrService: WksMistralOcrService
               ) {
                
                }

  async ngOnInit() {
    if (this._userService.getUserLogged() === undefined ) { return; }
    this.initDp();
    this.initAllBooleaans();
    this.settingFormats();
    this.initAllParam();
    this.initVariables();
    this.subscribeAll();
    
    await this.loadSuppliers()
    .then ((response2: any) => {
       this.loadWareHouses();
      })
    .catch ((error: any) => {
      console.log('loadSuppliers : ' + error);
      return;
    });
    
    this.getDeleveriesList('month', undefined);
    this.initializeScreen = true;
  }
  initAllBooleaans(): void {
    this.initializeScreen = false;
    this.addingDelivery = false;
    this.updateDelivery = false;
    this.doRegister = false;
    this.inputInProgress = false;
    this.readOnlyData = false;
    this.bsnSearch = false;

    this.createSupplier = false;
    this.showAlert = false; 
    this.scanCodeActivate = false;
    this.videoCodingDelivery = false;
  }
    
  initDp(): void {

    this.minDayDate = new Date(this.year - 1, this.month, this.day);
    this.maxDayDate = new Date();
    this.minDate = new Date(this.year - 1, this.month, this.day);
    this.maxDate =  new Date(this.year, this.month, this.day);

  }
  initAllParam(): void {
    this.wksEntity = this._wksCentralService.getWksEntityCur();
    const otherData = JSON.parse(this.wksEntity.otherData);
    const entityOptions = JSON.parse(this.wksEntity.entityOptions);
    const internationnalFormat = otherData.internationnalFormat;
    this.internationalsFormats = this._ressourcesService.getIntFormat(internationnalFormat);
    for (const fmtCur of this.internationalsFormats.datetime) {
      if (fmtCur.name === 'dateFormat') {
        this.dateFormat = fmtCur.value;
        this.dateFormatMoment = fmtCur.value;
        this.dateFormatMoment = this.dateFormatMoment.replace('dd', 'DD');
        this.dateFormatMoment = this.dateFormatMoment.replace('yyyy', 'YYYY');
      }
      if (fmtCur.name === 'timeFormat') {
        this.dateTimeFormat = fmtCur.value;
        this.dateTimeFormat = this.dateTimeFormat.replace('dd', 'DD');
        this.dateTimeFormat = this.dateTimeFormat.replace('yyyy', 'YYYY');
      }
    }
    this.defaultDateRef = new Date();
    this.datePickerConfig = {
        containerClass: 'theme-dark-blue',
        showWeekNumbers: false,
        minDate: this.minDate,
        maxDate: this.maxDate,
        dateInputFormat: this.dateFormat.toUpperCase(),
        isAnimated: true
      };
    if (this.fieldFormat.locale.toLowerCase() === 'fr-fr') {
      this._bsI18nService.setLanguage('fr');
    } else  {
      this._bsI18nService.setLanguage(this.fieldFormat.locale.toLowerCase());
    }
    this.scanCodeActivate = entityOptions.scanCodeActivation;
  }
  settingFormats(): void {
    const otherData = JSON.parse(this._wksCentralService.getWksEntityCur().otherData);
    const intFormat = otherData.internationnalFormat;
    this.numberFormat = {
      locale: this._ressourcesService.getFormat(intFormat, 'numbers', 'locale'),
      minDecimal: this._ressourcesService.getFormat(intFormat, 'numbers', 'minimumFractionDigits'),
      maxDecimal: this._ressourcesService.getFormat(intFormat, 'numbers', 'maximumFractionDigits'),
      currency:  this._ressourcesService.getFormat(intFormat, 'numbers', 'currency'),
    };
     this.fieldFormat = {
      locale: this._ressourcesService.getFormat(intFormat, 'numbers', 'locale'),
      minDecimal: this._ressourcesService.getFormat(intFormat, 'numbers', 'minimumFractionDigits'),
      maxDecimal: this._ressourcesService.getFormat(intFormat, 'numbers', 'maximumFractionDigits'),
      currency: this._ressourcesService.getFormat(intFormat, 'numbers', 'currency'),
      justifCurrency: this._ressourcesService.getFormat(intFormat, 'justifs', 'currency'),
      justifText: this._ressourcesService.getFormat(intFormat, 'justifs', 'text'),
      justifNumbers: this._ressourcesService.getFormat(intFormat, 'justifs', 'numbers'),
      language:  this._ressourcesService.getFormat(intFormat, 'numbers', 'language'),
    };
  }
  initVariables(): void {
    this.tabSelected = 0;
    this.timeFormat = this._translateService.getLocalFmt('timeFormat');
    this.entityCur = this._userService.getUserLogged().entity; 
    this.rowsParts = [];
    this.deliveryDate = new Date();
    this.titleCard = 'deliveriesListTitle';
    this.idxSelected = -1;
  }
  subscribeAll(): void {
    
  }
  loadSuppliers(): any {
    this.suppliersList = [];
    this.suppliersSelection = [];
    return new Promise((resolve, reject) => {
      this._wksCentralService.getWksBusinessList(this.entityCur, 'wks-suppliers')
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          this.suppliersList = data.body;
          this.suppliersList.sort((obj1, obj2) => {
            return obj1.bsnName > obj2.bsnName ? 1 : -1;
          });
          this.suppliersSelection = [...this.suppliersList];
          const blankSupplier: WksBusinessModel =  {
            id: 'blanck',
            bsnName: this._translateService.instant('NoSupplier')
          };
          this.suppliersSelection.unshift(blankSupplier);
          resolve(this.suppliersList);
        }, err => {
          // console.log(err);
          if (err.status === 404) {
            this.suppliersList.push({
              stdEntity: this.entityCur,
              bsnName: 'brand'
            });
          }
          reject(err.status);
        }
      );
    });
  }
  loadGedDocumentsWaiting(): void {

    this.wksGedDocumentService
        .getDocumentsByProcessingStatus(
            this._userService.getUserLogged().entity,
            'WAITING',
            'DELIVERY'
        )
        .subscribe(
            (documents: WksGedDocument[]) => {
                this.gedDocumentsWaiting = documents;
            },
            (error) => {
                console.error(
                    'Erreur récupération documents GED WAITING',
                    error
                );
            }
        );
  }
  loadWareHouses(): string {
    const apiService = 'warehousesList';
    const apiName = 'stockManagement';
    const toolArgs: ToolArgs = {
      toolDatas: []
    };
    let testData = {
      key: 'toolCustomerNwsCode',
      value: this.wksApisService.getApiStockManagement().toolCustomerNwsCode
    };
    toolArgs.toolDatas.push(testData);
    testData = {
      key: 'toolCustomerNwsId',
      value: this.wksApisService.getApiStockManagement().toolCustomerNwsId
    };
    toolArgs.toolDatas.push(testData);

    this.wksApisService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs )
    .subscribe(
      (data: any) => {
        const toolApiResponse = data.body as ToolApiResponse;
        if (toolApiResponse.statut === 'KO') {

        } else  {
          this.affectResponseWharehouses(toolApiResponse);
        }
      },
      err => {
        console.log('loadWareHouses error : ' + JSON.stringify(err));
      }
    );
    return this.warehouseIdCur;
  }
  affectResponseWharehouses(toolApiResponse: ToolApiResponse): void {
    this.wareHousesList = [];
    for (const wareHouseItem of toolApiResponse.toolDatas[0].listValues) {
      const itemWareHouse = {
        warehouseId: wareHouseItem.nws_wharehouse_id,
        warehouseRef: wareHouseItem.nws_wharehouse_ref
      };
      this.wareHousesList.push(itemWareHouse);
    }
    this.warehouseIdCur = this.wareHousesList[0].warehouseId;
  }
  toggleGedWaiting(): void {
    this.showGedWaiting = !this.showGedWaiting;

    if (this.showGedWaiting) {
        this.loadGedDocumentsWaiting();
    }
}
  getDeleveriesList(searchStatut: string, supplierId: string ): void {
    this.loadingIndicator = true;
    this.idxSelected = -1;
    let jsonArgs: {
      argStart: any;
      argEnd: any;
      brandRef: string;
      uuidItem: string;
      bsnId: string;
      searchStatut: string;
      deliveryStatut: string;
    };

    if (searchStatut === 'month') {
      const { startDate, endDate } = CommonMethods.getSlidingMonthBounds();
      jsonArgs = {
        argStart: startDate.getFullYear() + '-' +
                String(startDate.getMonth() + 1).padStart(2, '0') + '-' +
                String(startDate.getDate()).padStart(2, '0') + ' ' +
                String(startDate.getHours()).padStart(2, '0') + ':' +
                String(startDate.getMinutes()).padStart(2, '0') + ':' +
                String(startDate.getSeconds()).padStart(2, '0'),
        argEnd: endDate.getFullYear() + '-' +
                String(endDate.getMonth() + 1).padStart(2, '0') + '-' +
                String(endDate.getDate()).padStart(2, '0') + ' ' +
                String(endDate.getHours()).padStart(2, '0') + ':' +
                String(endDate.getMinutes()).padStart(2, '0') + ':' +
                String(endDate.getSeconds()).padStart(2, '0'),

        brandRef: '',
        uuidItem: '',
        bsnId: '',
        searchStatut: searchStatut,
        deliveryStatut: ''
      };
    }
    if (searchStatut === 'supplier') {

      jsonArgs = {
        argStart: '',
        argEnd: '',

        brandRef: '',
        uuidItem: '',
        bsnId: supplierId,
        searchStatut: searchStatut,
        deliveryStatut: ''
      };
    }
    this.partsDeliveriesList = [];
    this._wksCentralService.getWksPartsDelivery(this._userService.getUserLogged().entity, jsonArgs)
    .pipe(takeUntil(this.onDestroy))
    .subscribe(
      data => {
        // this.dataSource.data = data.body;
        this.partsDeliveriesList = data.body;
        this.rowsDeliveries = [];
        for (const item of this.partsDeliveriesList) {
          const blankRow = {
            isCollapsed: true,
            isSelected: false,
            toUpdate: false
          };
          this.rowsDeliveries.push(blankRow);
        }
        
        this.loadingIndicator = false;
      },
      err => {
        // console.log(err);
        this.loadingIndicator = false;
        if ((err.status === 500) || (err.status === 404)) {
          let titleBox: string;
          let messageBox: string;
          titleBox = 'searching deliveries';
          messageBox = 'no delivery found';
          titleBox = this._translateService.getTranslate(titleBox);
          messageBox = this._translateService.getTranslate(messageBox);
          this.displayMessageBox(titleBox, messageBox, 'ERROR', 'alertWks', 'readingDeliveries', null );
        }
      }
    );
  }
  // getWksPartsDeliveryDetail
  getDeleveriesListDetail(uuidDelivery: string, action: string): void {
    let jsonArgs: {
      argStart: any;
      argEnd: any;
      brandRef: string;
      uuidItem: string;
      bsnId: string;
      searchStatut: string;
      deliveryStatut: string;
    };

    jsonArgs = {
      argStart: '',
      argEnd: '',
      brandRef: '',
      uuidItem: uuidDelivery,
      bsnId: '',
      searchStatut: 'deliveryId',
      deliveryStatut: ''
    };
    
    this.partsDeliveriesDetailList = [];
    this.datasDeliveryDetail = [];
    this._wksCentralService.getWksPartsDeliveryDetail(this._userService.getUserLogged().entity, jsonArgs)
    .pipe(takeUntil(this.onDestroy))
    .subscribe(
      data => {
        // this.dataSource.data = data.body;
        this.partsDeliveriesDetailList = data.body;
        for (const item of this.partsDeliveriesDetailList) {
          const otherDatas = JSON.parse(item.otherDatas);
          // {"nws_movement_id":"2656","nws_label":"Test label 2"}
          const datas = {
            brandLabel: otherDatas.nws_label,
            movementId: otherDatas.nws_movement_id
          };
          item.supplierPackaging = Number(otherDatas.supplierPackaging);
          this.datasDeliveryDetail.push(datas);
        } 
        this.partsDeliveryRead.partsDeliveryDetail = this.partsDeliveriesDetailList;
        if (action === 'update') {
          // updateDelivery 
          this.titleCard = this._translateService.instant('updateDeliveryTitle');
          this.buildDeliveryForm('update');
          
          this.updateDelivery = true;
          this.inputInProgress = true;
        }      
      },
      err => {
        // console.log(err);
        if ((err.status === 500) || (err.status === 404)) {
           let titleBox: string;
          let messageBox: string;
          titleBox = 'searching delivery detail';
          messageBox = 'no delivery detail found';
          titleBox = this._translateService.getTranslate(titleBox);
          messageBox = this._translateService.getTranslate(messageBox);
          this.displayMessageBox(titleBox, messageBox, 'ERROR', 'alertWks', 'readingDeliveryDetail', null );
        }
      }
    );
  }
  addDelivery(): void {

    this.titleCard = this._translateService.instant('newDelivery');

    this.buildDeliveryForm('new');
    this.addingDelivery = true;
    this.inputInProgress = true;
  }

  buildDeliveryForm(statut: string): void {
    this.partDeliveryForm = this.fb.group({
      bsnIdFc: this.fb.control({value: '', disabled: this.readOnlyData }),
      deliveryRefFc: this.fb.control({value: '', disabled: this.readOnlyData }),
      orderRefFc: this.fb.control({value: '', disabled: this.readOnlyData }),
      warehouseFc: this.fb.control({value: '', disabled: this.readOnlyData }),
      deliveryDateFc: this.fb.control({value: '', disabled: this.readOnlyData }),
      rowsPartsFa: this.fb.array([]) ,
    });
    this.partDeliveryForm.controls.deliveryDateFc.setValue(this.deliveryDate);
    this.partDeliveryForm.controls.warehouseFc.setValue(this.wareHousesList[0].warehouseId);
    if (statut === 'new') {
    } else {
      this.fillFormDelivery('recorded');
    }

    this.initDeliveryFormSubscribe();
    /*
    setTimeout(() => {
      console.log('MANUAL PATCH');
      this.partDeliveryForm.patchValue({
        deliveryRefFc: 'TEST'
      });
    }, 10000);
    */
  }
  get rowsPartsFa(): FormArray {
    return this.partDeliveryForm.get('rowsPartsFa') as FormArray;
  }
  newPartRow(): FormGroup {

    return this.fb.group({
      barcodeFc: this.fb.control({value: '', disabled: this.readOnlyData}),
      brandRefFc: this.fb.control({value: '', disabled: this.readOnlyData}, [Validators.required]),
      brandLabelFc: this.fb.control({value: '', disabled: this.readOnlyData}, [Validators.required]),
      partQtyFc: this.fb.control({value: 0, disabled: this.readOnlyData}, [Validators.required, Validators.min(0.0000001)]),
      supplierPackagingFc: this.fb.control({value: 0, disabled: this.readOnlyData}, [Validators.required, Validators.min(1)]),
      partPurchaseFc: this.fb.control({value: 0, disabled: this.readOnlyData}),
      coefFc: this.fb.control({value: 1.20, disabled: this.readOnlyData}, [Validators.required, Validators.min(0)]),
      partSellingFc: this.fb.control({value: 0, disabled: this.readOnlyData}),
      stockIdFc: this.fb.control({value: '', disabled: true}, [Validators.required]),
    });
  }
  addRowPartsFa(): void {

    const rowEmpty: RowPart = {
      barcode: '',
      brandRef: '',
      brandLabel: '',
      partQty: 0,
      supplierPackaging: 1,
      partPurchase: 0,
      coef: 1.20,
      partSelling: 0,
      partStatut: '',
      stockId: '',
      partsSupplies: undefined,
      isCollapsed: true,
      odd: false,
      toCreate: false,
      isFound: false
    };

    this.rowsParts.push(rowEmpty);

    const rowForm = this.newPartRow();
    this.rowsPartsFa.push(rowForm);

    // Recalcul automatique du PV lorsque le PA ou le coef est modifié
    rowForm.get('partPurchaseFc')?.valueChanges.subscribe(() => {
      this.calculatePartSelling(rowForm);
    });

    rowForm.get('coefFc')?.valueChanges.subscribe(() => {
      this.calculatePartSelling(rowForm);
    });

    // si barcode gere par mdi-handheld-scanner
    /*
    if (this.scanCodeActivate) {
      this._wksCentralService.scanCodeFocus.emit((this.rowsParts.length - 1).toString());
    }*/
  }
  removeRowPartsFa(idxRowPart: number): void {
    this.rowsPartsFa.removeAt(idxRowPart);
    this.rowsParts[idxRowPart].partStatut = 'removed';

  }
  resetFormDelivery() {
    this.partDeliveryForm.reset({}, { emitEvent: false });
    this.rowsParts = [];
  }
  initDeliveryFormSubscribe(): void {

    this.partDeliveryForm.valueChanges.subscribe(x => {
      this.checkChanges();
    });

    this.rowsPartsFa.valueChanges.subscribe(x => {
      this.checkChanges();
    });

  }
  calculatePartSelling(row: FormGroup): void {

    let partPurchase = row.get('partPurchaseFc')?.value;
    let coef = row.get('coefFc')?.value;

    if (partPurchase === undefined || partPurchase === null || partPurchase === '') {
      return;
    }

    if (coef === undefined || coef === null || coef === '') {
      return;
    }

    if (typeof partPurchase === 'string') {
      partPurchase = parseFloat(
        partPurchase
          .replace(/\s/g, '')
          .replace(',', '.')
          .replace(/[A-Za-z€]/g, '')
      );
    }

    if (typeof coef === 'string') {
      coef = parseFloat(
        coef
          .replace(/\s/g, '')
          .replace(',', '.')
          .replace(/[A-Za-z€]/g, '')
      );
    }

    if (isNaN(partPurchase) || isNaN(coef)) {
      return;
    }

    const partSelling = partPurchase * coef;

    row.get('partSellingFc')?.setValue(
      partSelling,
      { emitEvent: false }
    );
  }
  checkChanges(): void {
    this.doRegister = false;

    const locItem = this.fillModel('');

    if (this.partDeliveryForm.valid && this.rowsPartsFa.valid) {
      if (!this.partDeliveryCache && this.rowsPartsFa.length > 0) {
        this.doRegister = true;
      } else if (JSON.stringify(this.partDeliveryCache) !== JSON.stringify(locItem) && this.rowsPartsFa.length > 0 ) {
        this.doRegister = true;
      }
    }
  }
  addSupplier(event: MouseEvent): void {

    // Blocage de l'ouverture du mat-select
    event.stopPropagation();
    event.preventDefault();

    const overlayRef = this.overlay.create({
      hasBackdrop: true, 
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.reposition()
    });

    // overlayRef.attach(new ComponentPortal(BnsCardSheetsComponent));
    const portal = new ComponentPortal(BnsCardSheetsComponent);
    const componentRef = overlayRef.attach(portal);

    // ✅ On passe les inputs ici
    componentRef.instance.statutCall = 'createBsn';
    componentRef.instance.optionItem = 'wks-suppliers';
    componentRef.instance.originCall = 'stocks-parts-delivery';
    componentRef.instance.dataOut.subscribe((result: WorkInputEvent) => {
      if (result.action === 'refresh') {
        this.loadSuppliers();
        overlayRef.dispose();
      } else if (result.action === 'cancel') {
        overlayRef.dispose();
      } 
    });

  }
  dataOutCreateSupplier($event: WorkInputEvent): void {
    console.log(JSON.stringify($event));

    this.loadSuppliers()
    .then ((response2: any) => {
     
      this.createSupplier = false;
      })
    .catch ((error: any) => {
      console.log('dataOutCreateSupplier ->> loadSuppliers : ' + error);
      return;
    });
  }
  onDatePickerChange(inputValue: any): void {
    if (inputValue === null) {
      this.deliveryDate = undefined;
    } else  {
      this.deliveryDate = inputValue;
    }
    this.ctrlIput();
  }
  bsnChoice(value: string): void {
    this.bsnCur = value;
  }
  warehouseChoice(value: string): void {
    this.warehouseIdCur = value;
  }
  focusOnScan(idxRow: number): void {
    this._wksCentralService.scanCodeFocus.emit(idxRow.toString());
  } 
  // si barcode gere par mdi-handheld-scanner
  /* 
  scannedResponse(eventTmp: any): void {
    // this.rowsParts[eventTmp.idxRow].barcode = eventTmp.scannedCode;
    this.rowsPartsFa.at(eventTmp.idxRow).get('barcodeFc').setValue(eventTmp.scannedCode);
    if (eventTmp.scannedCode !== undefined) {
      this.addRowPartsFa();
    }
  }
    */
  appliJob(): void {
    const rowCur = this.rowsParts.length;
    this.addRowPartsFa();
    this.rowsPartsFa.at(rowCur).get('barcodeFc').setValue(this.barcode);
    this.rowsParts[rowCur].barcode = this.barcode;
  }
  clearBarcode(idxRow: number): void {
    this.rowsPartsFa.at(idxRow).patchValue({
      barcodeFc: undefined,
      brandRefFc: undefined,
      brandLabelFc: undefined
    });
    this.rowsParts[idxRow].brandLabel = undefined;
    this.rowsParts[idxRow].barcode = undefined;
    this.rowsParts[idxRow].brandRef = undefined;
    this.rowsParts[idxRow].toCreate = false;
    this.rowsParts[idxRow].isFound = false;
  }
  clearBrandRef(idxRow: number): void {
    this.rowsPartsFa.at(idxRow).patchValue({
      brandRefFc: undefined,
      brandLabelFc: undefined
    });
    this.rowsParts[idxRow].brandLabel = undefined;
    this.rowsParts[idxRow].brandRef = undefined;
    this.rowsParts[idxRow].toCreate = false;
    this.rowsParts[idxRow].isFound = false;
  }
  searchReference(idxRow: number): void {
    const valueRef = this.rowsPartsFa.at(idxRow).get('brandRefFc')?.value;
    const valueBarCode = this.rowsPartsFa.at(idxRow).get('barcodeFc')?.value;
    if (valueBarCode && !valueRef) {
      this.readStockByBarcode(valueBarCode, idxRow);
    } else {
      this.readStockByRef(valueRef, idxRow);
    }
  } 
  addReference(idxRow: number): void {
    const overlayRef = this.overlay.create({
      hasBackdrop: true, 
      backdropClass: 'cdk-overlay-dark-backdrop',
      // panelClass: 'custom-overlay-panel',
      // width: '600px',
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.reposition()
    });

    // overlayRef.attach(new ComponentPortal(BnsCardSheetsComponent));
    const portal = new ComponentPortal(PartsSuppliesCardComponent);
    const componentRef = overlayRef.attach(portal);

    // ✅ On passe les inputs ici
    componentRef.instance.statutCall = 'stock-cdk';
    componentRef.instance.optionItem = '';
    componentRef.instance.actionType = 'add';
    componentRef.instance.partSupplieToUpdate = undefined;
    componentRef.instance.brandRefArg = this.rowsPartsFa.at(idxRow).get('brandRefFc')?.value;
    componentRef.instance.barCodeArg = this.rowsPartsFa.at(idxRow).get('barcodeFc')?.value;
    
    componentRef.instance.dataOut.subscribe((result: string) => {
      if (result.startsWith('added')) {
        this.rowsParts[idxRow].isFound = false;
        this.rowsParts[idxRow].toCreate = false;
        const arg = result.split('=');
        this.rowsPartsFa.at(idxRow).patchValue({
          brandRefFc: arg[1]
        });
        this.rowsParts[idxRow].brandRef = arg[1];
        overlayRef.dispose();
      } else if (result === 'cancel') {
        overlayRef.dispose();
      } else  {
        console.log('Résultat :', JSON.stringify(result));
        overlayRef.dispose();
      }
    
    });
    
   componentRef.instance.initData();
   componentRef.changeDetectorRef.detectChanges();
  }
  numberAndDotOnly(event: any): boolean {
    return CommonMethods.numberAndDotOnly(event);
  }
  handleEnter(event: KeyboardEvent) {
    event.preventDefault(); // Empêche l'ajout automatique
    // console.log('Enter pressé mais sans ajout !');
  }
  formatNumericField(fieldName: string, idxRow: number): void {
    switch (fieldName) {
      case 'partQty': {
        let valueArg = this.rowsPartsFa.at(idxRow).get('partQtyFc')?.value;
        if (valueArg === undefined) {
          valueArg = 0;
        }
        let returnValue = this._translateService.instantNumber(valueArg, ['quantity', this.numberFormat.locale, this.numberFormat.minDecimal, this.numberFormat.maxDecimal]) as string;
        returnValue = returnValue.replace(/\s/g, '').replace(',', '.');
        this.rowsPartsFa.at(idxRow).patchValue({
          partQtyFc: returnValue
        });

        break;
      }
      case 'supplierPackaging': {
        let valueArg = this.rowsPartsFa.at(idxRow).get('supplierPackagingFc')?.value;
        if (valueArg === undefined) {
          valueArg = 1;
        }
        let returnValue = this._translateService.instantNumber(valueArg, ['quantity', this.numberFormat.locale, this.numberFormat.minDecimal, this.numberFormat.maxDecimal]) as string;
        returnValue = returnValue.replace(/\s/g, '').replace(',', '.');
        this.rowsPartsFa.at(idxRow).patchValue({
          supplierPackagingFc: returnValue
        });

        break;
      }
      case 'partPurchase': {
        let valueArg = this.rowsPartsFa.at(idxRow).get('partPurchaseFc')?.value;
        if (valueArg === undefined) {
          valueArg = 0;
        }
        let returnValue = this._translateService.instantNumber(valueArg, ['currency', this.numberFormat.locale, this.numberFormat.currency, 'symbol']) as string;
        returnValue = returnValue.replace(/\s/g, '').replace(',', '.');
        this.rowsPartsFa.at(idxRow).patchValue({
          partPurchaseFc: returnValue
        });

        break;
      }
      case 'coef': {
        let valueArg = this.rowsPartsFa.at(idxRow).get('coefFc')?.value;
        if (valueArg === undefined) {
          valueArg = 1.20;
        }
        let returnValue = this._translateService.instantNumber(valueArg, ['quantity', this.numberFormat.locale, this.numberFormat.minDecimal, this.numberFormat.maxDecimal]) as string;
        returnValue = returnValue.replace(/\s/g, '').replace(',', '.');
        this.rowsPartsFa.at(idxRow).patchValue({
          coefFc: returnValue
        });

        break;
      }
      case 'partSelling': {
        let valueArg = this.rowsPartsFa.at(idxRow).get('partSellingFc')?.value;
        if (valueArg === undefined) {
          valueArg = 0;
        }
        let returnValue = this._translateService.instantNumber(valueArg, ['currency', this.numberFormat.locale, this.numberFormat.currency, 'symbol']) as string;
        returnValue = returnValue.replace(/\s/g, '').replace(',', '.');
        this.rowsPartsFa.at(idxRow).patchValue({
          partSellingFc: returnValue
        });

        break;
      }
    }
  }

  unformatNumericField(fieldName: string, idxRow: number): void {
    switch (fieldName) {
      case 'partQty': {
        this.rowsPartsFa.at(idxRow).patchValue({
          partQtyFc: undefined
        });
        break;
      }
      case 'supplierPackaging': {
        this.rowsPartsFa.at(idxRow).patchValue({
          supplierPackagingFc: undefined
        });
        break;
      }
      case 'partPurchase': {
        this.rowsPartsFa.at(idxRow).patchValue({
          partPurchaseFc: undefined
        });
        break;
      }
      case 'coef': {
        this.rowsPartsFa.at(idxRow).patchValue({
          coefFc: undefined
        });
        break;
      }
      case 'partSelling': {
        this.rowsPartsFa.at(idxRow).patchValue({
          partSellingFc: undefined
        });
        break;
      }
    }
  }
  ctrlIput(): void {
    
  }
  
  updateDetail(idxRow: number): void {
   for (const item of this.rowsDeliveries) {
      item.isCollapsed = true;
      item.isSelected = false;
    }
    this.idxSelected = idxRow;
    this.partsDeliveriesDetailList = [];
    this.datasDeliveryDetail = [];
    this.partsDeliveryRead = this.partsDeliveriesList[this.idxSelected];
    this.getDeleveriesListDetail(this.partsDeliveriesList[idxRow].id, 'update');
  }
  lineDetail(idxRow: number): void {
    for (const item of this.rowsDeliveries) {
      item.isCollapsed = true;
      item.isSelected = false;
    }
    this.idxSelected = idxRow;
    this.rowsDeliveries[idxRow].isCollapsed = false;
    this.rowsDeliveries[idxRow].isSelected = true;
    this.getDeleveriesListDetail(this.partsDeliveriesList[idxRow].id, null);
  }
  cancelPartsDelivery(): void {
    this.closeFormDelivery();
  }
  refresh(): void {
    this.bsnSelect('blanck');
    this.getDeleveriesList('month', undefined);
  }
  bsnSelect(value: string): void {
    this.bsnSelected = value;
    this.bsnSearch = false;
    if (value === 'blanck') {
      return;
    }
    this.bsnSearch = true;
  }
  searchSupplier(): void {
    this.getDeleveriesList('supplier', this.bsnSelected);
  }

  // SCANNER & VIDEO CODAGE
  startDeliveryScanSequence(): void {
    
    const dialogConfig = new MatDialogConfig();
       
        dialogConfig.panelClass = 'ged-scanner-dialog-panel';
        dialogConfig.height = '650px';
        dialogConfig.width = '650px';
        dialogConfig.maxHeight = '90vh';
        dialogConfig.maxWidth = '90vw';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
          id: 1,
          title: this._translateService.getTranslate('changeWorkStatut'),
          typeDialog: '',
          panelClass: 'stdTheme',
          contentMessage: '',
          data1: '',
          data2: '',
          messageType: '',
          tenant: this._userService.getUserLogged().entity,
          business: 'DELIVERY'
          };
    
        const dialogRef = this._dialog.open(GedScannerComponent, dialogConfig);
    
        dialogRef.afterClosed()
        .pipe(takeUntil(this.onDestroy))
        .subscribe(
          data => {
            // console.log('Dialog output:', data);
            if ( data.action === 'okAction'  )  {
                this.loadGedDocumentsWaiting();
                // console.log(rowNode);
            }
            if ( data.action === 'cancelAction')  {
           
            }
          });
  }
  viewGedDocument(document: WksGedDocument): void {

    if (this.gedDocumentImageUrl) {
        URL.revokeObjectURL(this.gedDocumentImageUrl);
    }

    this.gedDocumentImageUrl = undefined;
    this.gedDocumentImageSafeUrl = undefined;

    this.gedDocumentImage = document;
    this.gedDocumentImageZoom = 1;
    this.gedDocumentImageLoading = true;
    this.gedDocumentImageVisible = true;

    this.wksGedDocumentService
        .getDocumentContent(document)
        .subscribe(
            blob => {

                // console.log('GED blob type =', blob.type);
                // console.log('GED blob size =', blob.size);

                this.gedDocumentImageUrl =
                    URL.createObjectURL(blob);

                this.gedDocumentImageSafeUrl =
                    this.sanitizer.bypassSecurityTrustUrl(
                        this.gedDocumentImageUrl
                    );

                this.gedDocumentImageLoading = false;
            },
            error => {

                console.error(
                    'Erreur lecture document GED :',
                    error
                );

                this.gedDocumentImageLoading = false;
                this.gedDocumentImageVisible = false;
            }
        );
  }
  closeGedDocumentImage(): void {

    if (this.gedDocumentImageUrl) {
        URL.revokeObjectURL(
            this.gedDocumentImageUrl
        );
    }

    this.gedDocumentImageUrl = undefined;
    this.gedDocumentImageSafeUrl = undefined;
    this.gedDocumentImage = undefined;
    this.gedDocumentImageVisible = false;
  }
  zoomGedDocumentIn(): void {
    this.gedDocumentImageZoom += 0.20;

    if (this.gedDocumentImageZoom > 3) {
        this.gedDocumentImageZoom = 3;
    }
  }

  zoomGedDocumentOut(): void {
      this.gedDocumentImageZoom -= 0.20;

      if (this.gedDocumentImageZoom < 0.20) {
          this.gedDocumentImageZoom = 0.20;
      }
  }

  resetGedDocumentZoom(): void {
      this.gedDocumentImageZoom = 1;
  }
  startVideoCoding(
    document: WksGedDocument
    ): void {

    this.gedDocumentVideoCoding = document;

    if (this.gedDocumentImageUrl) {
        URL.revokeObjectURL(this.gedDocumentImageUrl);
    }

    this.gedDocumentImageUrl = undefined;
    this.gedDocumentImageSafeUrl = undefined;
    this.gedDocumentImageZoom = 1;

    // Affiche immédiatement la vue vidéo-codage
    this.videoCodingDelivery = true;
    this.inputInProgress = true;

    // Pendant le chargement du document
    this.gedDocumentImageLoading = true;

    this.wksGedDocumentService
        .getDocumentContent(document)
        .subscribe(
            blob => {

                // console.log('GED blob type =', blob.type);
                // console.log('GED blob size =', blob.size);
                this.gedDocumentImageBlob = blob;
                this.gedDocumentImageUrl =
                    URL.createObjectURL(blob);

                this.gedDocumentImageSafeUrl =
                    this.sanitizer.bypassSecurityTrustUrl(
                        this.gedDocumentImageUrl
                    );

                this.gedDocumentImageLoading = false;

                this.titleCard =
                    this._translateService.instant(
                        'newDelivery'
                    );

                this.addDelivery();
            },
            error => {

                console.error(
                    'Erreur récupération document GED :',
                    error
                );

                this.gedDocumentImageLoading = false;
                this.videoCodingDelivery = false;
            }
        );
  }
  processVideoCodingDocument(): void {

    if (!this.gedDocumentVideoCoding) {
        return;
    }
    /*
    if (this._wksCentralService.getentityOCR() !== undefined) {
        if (this._wksCentralService.getentityOCR().nameOCR === 'MistralOCR') {
          this.extractMistralOCR(this._wksCentralService.getentityOCR());
        }
      return;
    }
    */

    if (this._wksCentralService.getentityOCR() !== undefined) {       
      this.gedDocumentVideoCoding.entityOCR = this._wksCentralService.getentityOCR();
    }
    this.videoCodingProcessing = true;

    this.wksGedDocumentService
        .getDocumentOcr(this.gedDocumentVideoCoding)
        .subscribe(
            (ocrText: string) => {
                // console.log('OCR document :', ocrText);
                this.affectDataOCR(ocrText);
                this.videoCodingProcessing = false;
            },
            error => {
                console.error('Erreur OCR document :', error);
                this.videoCodingProcessing = false;
            }
        );
  }
  // ============================================================================================================================
  // JLG - 2026-10-07
  // service opérationnel sans l'anti-virus dans le navigateur. 
  // l'url de mistral-ai est black-listée par avast 
  // De ce fait passage à la version back-end en Java
  // ============================================================================================================================
  extractMistralOCR(entityOCR: EntityOCR): void {

    this.videoCodingProcessing = true;
    let error = '';
    let result = null;

    this.mistralOcrService.ocrAnnote({
      pngBlob: this.gedDocumentImageBlob,
      apiKey: entityOCR.apiKeyOCR,
      schemaName: entityOCR.schemaNameOCR,
      schemaJson: entityOCR.schemaPropertiesOCR,
      prompt: entityOCR.promptOCR
    }).subscribe(
      annotation => {
        result = annotation;
        this.videoCodingProcessing = false;
      },
      (err: HttpErrorResponse) => {
        error = this.getErrorMessage(err);
        console.log(error);
        this.videoCodingProcessing = false;
      },
      () => {
        // optionnel : fin du flux (succès ou erreur)
        this.videoCodingProcessing = false;
      }
    );
  }

  /** Traduit les erreurs HTTP / API en message métier */
  private getErrorMessage(err: HttpErrorResponse): string {
    switch (err.status) {
      case 0:
        return 'Serveur injoignable (réseau ou CORS). Vérifiez votre connexion.';
      case 401:
        return 'Clé API invalide ou expirée.';
      case 422:
        return 'Erreur 422 : ' + JSON.stringify(err.error);
      case 429:
        return 'Trop de requêtes : quota dépassé, réessayez dans un instant.';
      default:
        if (err.error && err.error.message) {
          return err.error.message;
        }
        return 'Erreur inattendue (' + err.status + ') : ' + err.message;
    }
  }

  /** Extrait le détail d'une erreur 422 (liste des problèmes de schéma) */
  private extractDetail(err: HttpErrorResponse): string {
    const body = err.error;
    if (body && body.detail) {
      if (Array.isArray(body.detail)) {
        // FastAPI-style : [{ msg: "...", loc: [...] }]
        return body.detail.map((d: any) => d.msg).join(', ');
      }
      return String(body.detail);
    }
    return err.message;
  }
 // VIDEO CODAGE
  async  affectDataOCR(ocrText: string): Promise<void> {

    const ocrJson = JSON.parse(ocrText) as OcrBonLivraison;
    
    // AFfecter les données reçues
    // this.partDeliveryForm.get('warehouseFc')?.disable();
    // this.partDeliveryForm.get('bsnIdFc')?.disable();
    // const [day, month, year] = ocrJson.date_livraison.split('/');
    // const dateISO = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    const wksPartsDelivery: WksPartsDelivery = {
      id: '',
      stdEntity: '',
      bsnId: this.partDeliveryForm.controls.bsnIdFc.value,
      deliveryDate: this.parseFrenchDate(ocrJson.date_livraison),
      deliveryRef: ocrJson.numero_bl,
      orderRef: '',
      deliveryStatut: '',
      warehouseId: this.warehouseIdCur,
      otherDatas: JSON.stringify({
          total_ht: ocrJson.total_ht,
          total_tva: ocrJson.total_tva,
          total_ttc: ocrJson.total_ttc
      }),
      partsDeliveryDetail: ocrJson.lignes.map((ligne: any) => ({
          id: '',
          stdEntity: '',
          deliveryId: '',
          brandRef: ligne.reference,
          partQty: Number(ligne.quantite),
          supplierPackaging: 1,
          partPurchase: this.parseAmount(ligne.pu_net),
          partSelling: this.parseAmount(''),
          partStatut: '',
          otherDatas: JSON.stringify({
              nws_label: ligne.designation,
              remise: ligne.remise,
              pt_ht: ligne.pt_ht
          }),
          stockId: '',
          marginSale: 0
      }))
    };
    // console.log(wksPartsDelivery);
    this.partsDeliveryRead = wksPartsDelivery;
    this.partsDeliveriesDetailList = this.partsDeliveryRead.partsDeliveryDetail;
    this.datasDeliveryDetail = [];    
    let idxNum = 0;
    for (const itemPart of this.partsDeliveryRead.partsDeliveryDetail) {
      const otherDatas = JSON.parse(itemPart.otherDatas);
          // {"nws_movement_id":"2656","nws_label":"Test label 2"}
        const datas = {
          brandLabel: otherDatas.nws_label,
          movementId: otherDatas.nws_movement_id
        };
        let itemPackaging = Number(otherDatas.supplierPackaging);
        if (Number.isNaN(itemPackaging)) {
          itemPackaging = 1;
        }
        itemPart.supplierPackaging = itemPackaging !== undefined && itemPackaging !== 0 ? itemPackaging : 1;
        this.datasDeliveryDetail.push(datas);
      idxNum++;
    }
    this.fillFormDelivery('');
    // lire les referénces et récupérer les coef et les conditionnements

    idxNum = 0;
    for (const itemPart of this.partsDeliveryRead.partsDeliveryDetail) {
      await this.readStockByRef(itemPart.brandRef, idxNum);
      this.rowsParts[idxNum].supplierPackaging = itemPart.supplierPackaging;
      this.rowsPartsFa.at(idxNum).patchValue({
          supplierPackagingFc: itemPart.supplierPackaging
      });
      idxNum++;
    }

  
  }
  private parseAmount(value: string): number {
    if (!value) {
        return 0;
    }

    return Number(
        value
            .replace('€', '')
            .replace(/\s/g, '')
            .replace(',', '.')
    );
  }
  private parseFrenchDate(value: string): Date {
    const [day, month, year] = value.split('/');

    let newYear =  Number(year)
    if ( newYear < 100) {
      newYear = 2000 + Number(year);
    }

    return new Date(
        Number(newYear),
        Number(month) - 1,
        Number(day)
    );
  }
 // FIN SCANNER & VIDEO CODAGE
  registerPartsDelivery(): void {
    let action = 'update';
    if (this.addingDelivery) {
      action = 'addingDelivery';
    }
    if (this.videoCodingDelivery) {
      action = 'videoCodingDelivery';
    }
   
    const locItem = this.fillModel('register');
    this.updateBarcodes();
    // console.log(JSON.stringify(locItem));
    this._wksCentralService.saveWksPartsDelivery(locItem, action )
    .subscribe(
      (data: any) => {
        this.closeFormDelivery();
      },
      err => {
          console.log('registerPartsDelivery error' + JSON.stringify(err));
          const titleBox = this._translateService.getTranslate('stocks-parts-delivery validate delivery part');
          const messageBox = this._translateService.instant('stocks-parts-delivery writing error ', [locItem.deliveryRef]);
          this.displayMessageBox(titleBox, messageBox, 'ERROR', 'alertWks', '', null );
      }
    );
  }
closeFormDelivery(): void {

    this.resetFormDelivery();
    this.addingDelivery = false;
    this.updateDelivery = false;
    this.videoCodingDelivery = false;
    this.gedDocumentVideoCoding = undefined;
    this.inputInProgress = false;
    this.doRegister = false;
    this.titleCard = 'deliveriesListTitle';
    this.refresh();
}
  fillFormDelivery(statutCur: string): void {

    this.partDeliveryForm.get('warehouseFc')?.disable();
    this.partDeliveryForm.get('bsnIdFc')?.disable();

    this.deliveryDate = new Date(this.partsDeliveryRead.deliveryDate);
    this.warehouseIdCur = this.partsDeliveryRead.warehouseId;
    this.partDeliveryForm.controls.bsnIdFc.setValue(this.partsDeliveryRead.bsnId);
    this.partDeliveryForm.controls.deliveryRefFc.setValue(this.partsDeliveryRead.deliveryRef);
    this.partDeliveryForm.controls.orderRefFc.setValue(this.partsDeliveryRead.orderRef);
    this.partDeliveryForm.controls.deliveryDateFc.setValue(this.deliveryDate);
    this.partDeliveryForm.controls.warehouseFc.setValue(this.partsDeliveryRead.warehouseId);
    
    this.fillFormDeliveryDetail(statutCur);

  }
  fillFormDeliveryDetail(statutCur: string): void {
    this.rowsParts = [];
      // Vider les anciennes lignes
    while (this.rowsPartsFa.length !== 0) {
      this.rowsPartsFa.removeAt(0);
    }

    let idxPart = 0;
    for (const itemDetail of this.partsDeliveriesDetailList) {
      const jsonData = JSON.parse(itemDetail.otherDatas);
      const rowForm = this.newPartRow();
      this.rowsPartsFa.push(rowForm);

      // Recalcul automatique du PV lorsque le PA ou le coef est modifié
      rowForm.get('partPurchaseFc')?.valueChanges.subscribe(() => {
        this.calculatePartSelling(rowForm);
      });

      rowForm.get('coefFc')?.valueChanges.subscribe(() => {
        this.calculatePartSelling(rowForm);
      });
      const rowPart = this.rowsPartsFa;
      const rowItem = rowPart.at(idxPart);
      /*
      rowItem.get('brandRefFc')?.disable();
      rowItem.get('brandLabelFc')?.disable();
      rowItem.get('partQtyFc')?.disable();
      rowItem.get('partPurchaseFc')?.disable();
      rowItem.get('partSellingFc')?.disable();
      rowItem.get('supplierPackagingFc')?.disable();
      rowItem.get('stockIdFc')?.disable();
      */
      let otherDatasTmp = (itemDetail.otherDatas !== undefined  ? JSON.parse(itemDetail.otherDatas) : undefined);
      if (otherDatasTmp === undefined) {
        otherDatasTmp = {  };
      }
      const coefTmp = otherDatasTmp.coef !== undefined ? Number(otherDatasTmp.coef) : 1.20;
      const barcodeTmp = otherDatasTmp.barcode !== undefined ? otherDatasTmp.barcode : ''; 
      const rowCur: RowPart = {
        barcode: barcodeTmp,
        brandRef: itemDetail.brandRef,
        brandLabel: this.datasDeliveryDetail[idxPart].brandLabel,
        partQty: itemDetail.partQty,
        supplierPackaging: jsonData.supplierPackaging,
        partPurchase: itemDetail.partPurchase,
        partSelling: itemDetail.partSelling,
        coef: coefTmp,
        partStatut: statutCur,
        stockId: itemDetail.stockId,
        partsSupplies: undefined,
        isCollapsed: true,
        odd: false,
        toCreate: false,
        isFound: false
      };
      this.rowsParts.push(rowCur);
      rowItem.get('brandRefFc').setValue(rowCur.brandRef);
      rowItem.get('brandLabelFc').setValue(rowCur.brandLabel);
      rowItem.get('partQtyFc').setValue(rowCur.partQty);
      rowItem.get('supplierPackagingFc').setValue(rowCur.supplierPackaging);
      rowItem.get('partPurchaseFc').setValue(rowCur.partPurchase);
      rowItem.get('coefFc').setValue(rowCur.coef);
      rowItem.get('partSellingFc').setValue(rowCur.partSelling);
      rowItem.get('stockIdFc').setValue(rowCur.stockId);

      this.formatNumericField('partQty', idxPart);
      this.formatNumericField('partPurchase', idxPart);
      this.formatNumericField('partSelling', idxPart);

      idxPart++;
    }
  }
  getFormatDate(dateCur: Date): string {  
    const date = new Date(dateCur);
    const dateStr = date.toLocaleDateString(this.fieldFormat.locale);
    return dateStr;
  }
  fillModel(optionCur: string): WksPartsDelivery {

    let otherDatasJson = {  };
    if (this.videoCodingDelivery) {  
      otherDatasJson  = { 
        'videoCodingDelivery': this.gedDocumentVideoCoding.id
       };
    }
    const partsDelivery: WksPartsDelivery = {
      id: (this.partsDeliveryRead !== undefined && this.partsDeliveryRead.id ? this.partsDeliveryRead.id : undefined),
      stdEntity: this.entityCur,
      bsnId: this.partDeliveryForm.controls.bsnIdFc.value,
      deliveryDate: this.partDeliveryForm.controls.deliveryDateFc.value,
      deliveryRef: this.partDeliveryForm.controls.deliveryRefFc.value,
      orderRef: this.partDeliveryForm.controls.orderRefFc.value,
      deliveryStatut: undefined,
      warehouseId: this.partDeliveryForm.controls.warehouseFc.value,
      otherDatas: JSON.stringify(otherDatasJson),
      partsDeliveryDetail: this.fillModelDetail(optionCur, this.partDeliveryForm.controls.bsnIdFc.value)
    };
    return partsDelivery;
  }
  fillModelDetail(optionCur: string, bsnIdCur: string):  WksPartsDeliveryDetail[] {
    const partsDeliveryDetail: WksPartsDeliveryDetail[] = [];
    const partsDeliveryDetailRead = (this.partsDeliveryRead !== undefined && this.partsDeliveryRead.partsDeliveryDetail !== undefined ? 
                                      this.partsDeliveryRead.partsDeliveryDetail as  WksPartsDeliveryDetail[] : undefined);
    const nbRead = ( partsDeliveryDetailRead !== undefined ? partsDeliveryDetailRead.length : -1);
    const nbRow = this.rowsPartsFa.length;
    // returnValue = returnValue.replace(/\s/g, '').replace(',', '.'); // Enlever espaces et convertir la virgule en point

    for (let i = 0; i < nbRow; i++ ) {
      const itemCurRef = (this.rowsPartsFa.at(i) as FormGroup).get('brandRefFc').value;
      if (itemCurRef === undefined || itemCurRef === null) {
        continue;
      }

      let otherDatasTmp = (this.partsDeliveryRead !== undefined && 
                        this.partsDeliveryRead.partsDeliveryDetail !== undefined && 
                        this.partsDeliveryRead.partsDeliveryDetail[i] !== undefined  ? 
                          JSON.parse(this.partsDeliveryRead.partsDeliveryDetail[i].otherDatas) : undefined);
      if (otherDatasTmp === undefined) {
        otherDatasTmp = {  };
      }
      otherDatasTmp.nws_movement_id = '';
      otherDatasTmp.nws_label = (this.rowsPartsFa.at(i) as FormGroup).get('brandLabelFc').value;
      otherDatasTmp.brandBarcode = this.rowsParts !== undefined && this.rowsParts[i] !== undefined ? this.rowsParts[i].barcode : '';
      otherDatasTmp.supplierPackaging = (this.rowsPartsFa.at(i) as FormGroup).get('supplierPackagingFc').value;
      otherDatasTmp.coef = (this.rowsPartsFa.at(i) as FormGroup).get('coefFc').value;

      let purchase = (this.rowsPartsFa.at(i) as FormGroup).get('partPurchaseFc').value;
      if (purchase !== 0 && purchase !== undefined) {
        try {
          purchase = parseFloat(purchase
                .replace(/\s/g, '')
                .replace(',', '.')
                .replace(/[A-Za-z]/g, ''));
        } catch {
          purchase = parseFloat(purchase);
        }
      }  
      let selling = (this.rowsPartsFa.at(i) as FormGroup).get('partSellingFc').value;
      if (selling !== 0 && selling !== undefined) {
        try {
          selling = parseFloat(selling
                .replace(/\s/g, '')
                .replace(',', '.')
                .replace(/[A-Za-z]/g, '')
            );
        } catch {
          selling = parseFloat(selling);
        }    
      }
      const curentpartsDeliveryDetail: WksPartsDeliveryDetail = {
        id: (nbRead > 0 && partsDeliveryDetailRead !== undefined && partsDeliveryDetailRead[i] !== undefined ? partsDeliveryDetailRead[i].id : undefined),
        stdEntity: this.entityCur,
        deliveryId: (this.partsDeliveryRead !== undefined && this.partsDeliveryRead.id ? this.partsDeliveryRead.id : null),
        brandRef: (this.rowsPartsFa.at(i) as FormGroup).get('brandRefFc').value,
        partQty: (this.rowsPartsFa.at(i) as FormGroup).get('partQtyFc').value,
        supplierPackaging: (this.rowsPartsFa.at(i) as FormGroup).get('supplierPackagingFc').value,
        partPurchase: purchase,
        partSelling: selling,
        partStatut: this.rowsParts !== undefined && this.rowsParts[i] !== undefined ? this.rowsParts[i].partStatut : '',
        otherDatas: JSON.stringify(otherDatasTmp),
        stockId: (this.rowsPartsFa.at(i) as FormGroup).get('stockIdFc').value,
      };
      if (optionCur === 'register') {
        let bsnName;
        for (const itemBsn of this.suppliersList) {
          if (itemBsn.id === bsnIdCur) {
            bsnName = itemBsn.bsnName;
            break;
          }
        }
        curentpartsDeliveryDetail.supplierName = bsnName;
      }
      partsDeliveryDetail.push(curentpartsDeliveryDetail);
    }

    return partsDeliveryDetail;
   }    
  doCancel(): void {

    this.router.navigate(['/jobHome']);
    
  }
 
  async readStockByRef(brandRef: string, idxRow: number): Promise<void> {

    const apiService = 'stockByRef';
    const apiName = 'stockManagement';

    const toolArgs: ToolArgs = {
      toolDatas: []
    };

    let testData = {
      key: 'toolCustomerNwsCode',
      value: this.wksApisService.getApiStockManagement().toolCustomerNwsCode
    };
    toolArgs.toolDatas.push(testData);

    testData = {
      key: 'toolCustomerNwsId',
      value: this.wksApisService.getApiStockManagement().toolCustomerNwsId
    };
    toolArgs.toolDatas.push(testData);

    const toolKeyValue: ToolKeyValue = {
      key: 'brandRef',
      value: brandRef,
      listValues: undefined,
      arrayValues: undefined
    };

    toolArgs.toolDatas.push(JSON.parse(JSON.stringify(toolKeyValue)));

    try {
      const data = await this.wksApisService.requestApis(
        this.wksEntity.stdEntity,
        apiName,
        apiService,
        toolArgs
      ).toPromise();
      const toolApiResponse = data.body as ToolApiResponse;
      if (toolApiResponse.statut === 'KO') {
        const itemResponse = toolApiResponse.toolDatas[0];
        if (itemResponse.value === '404') {
          this.rowsParts[idxRow].toCreate = true;
          this.rowsParts[idxRow].isFound = false;
          this.triggerAlert(brandRef, 'brandRefNotFound');
        }
        return;
      }
      this.affectResponseStockByRef(toolApiResponse, idxRow);
      this.searchBrandrefReferencial(brandRef, idxRow);
    } catch (err) {
      console.log('readStockByRef : ' + JSON.stringify(err));
    }
  }
  affectResponseStockByRef(toolApiResponse: ToolApiResponse, idxRow: number ): void {

    for (const itemCur of toolApiResponse.toolDatas) {
      if (itemCur.key === 'nws_label') {
        this.rowsPartsFa.at(idxRow).patchValue({
          brandLabelFc: itemCur.value
        });
        this.rowsParts[idxRow].brandLabel = itemCur.value;
        this.rowsParts[idxRow].isFound = true;
      }  
      if (itemCur.key === 'nws_stock_id') {
        this.rowsPartsFa.at(idxRow).patchValue({
          stockIdFc: itemCur.value
        });
        this.rowsParts[idxRow].stockId = itemCur.value;
      }     
    }
  }
  // read referencial
  async searchBrandrefReferencial( brandRef: string, idxRow: number ): Promise<void> {
    try {
      const data = await this._wksCentralService
        .getParamPartsSupplieSelect(this._userService.getUserLogged().entity, '', '', brandRef,
          this._userService.getUserLogged().userlang
        )
        .pipe(
          takeUntil(this.onDestroy)
        )
        .toPromise();
      const response = data.body as ParamPartsSuppliesModel[];
      if (response.length > 1) {

      } else if (response.length === 1) {
        this.affectResponseReferential(response[0], idxRow);
      }
    } catch (err) {
      console.log(err);
    }
  }
  affectResponseReferential(paramPartsSupplies: ParamPartsSuppliesModel, idxRow: number): void {
    this.rowsParts[idxRow].partsSupplies = paramPartsSupplies;
    this.rowsParts[idxRow].brandRef  = paramPartsSupplies.brandRef;
    const jsonData = JSON.parse(paramPartsSupplies.otherData);
    let supplierPackaging = 1;
    if (jsonData !== null && jsonData !== undefined) {
      if (jsonData.supplierPackaging !== undefined ) {
        supplierPackaging = Number(jsonData.supplierPackaging);
        if (supplierPackaging === 0) {
          supplierPackaging = 1;
        }
      }
    }
    this.rowsParts[idxRow].supplierPackaging  = supplierPackaging;
    this.rowsPartsFa.at(idxRow).patchValue({
      supplierPackagingFc: supplierPackaging
    });
  }
  // read by barcode
  readStockByBarcode(inputValue: string, idxRow: number): void {
    
    if (inputValue.trim().length < this.MIN_CAR) {
      return;
    }
    this.rowsParts[idxRow].isFound = true;

    let messageDisplay: MessageDisplay = {
      titleBox: this._translateService.instant('searchListPartsTitle'),
      messageLabel: this._translateService.instant('selection_search', [inputValue]),
      messageArgs: undefined,
      messageType: 'ERROR',
      messageDatas: undefined,
      typeDialog: 'infoProgressWks',
      actionCur: 'searchListParts',
      progressDeterminate: false,
    };
    
    this.displayMessageBox(messageDisplay.titleBox, messageDisplay.messageLabel, messageDisplay.messageType, messageDisplay.typeDialog, messageDisplay.actionCur, undefined);
    this._wksCentralService.getParamPartSupplieList(this.wksEntity.stdEntity, '', 'part', this._userService.getUserLogged().userlang, inputValue, true )
    .subscribe(
      (data: any) => {
        this.closeMatDialog();
        const paramPartsSuppliesList = data.body as ParamPartsSuppliesModel[];
        this.affectResponseSearchReferential(paramPartsSuppliesList, idxRow);
        this.closeMatDialog();
      },
      err => {
        this.closeMatDialog();
        this.rowsParts[idxRow].isFound = false;
        if (err.status === 404 ) {
          messageDisplay = {
            titleBox: this._translateService.instant('searchListPartsTitle'),
            messageLabel: this._translateService.instant('selection_search_KO11', [inputValue]),
            messageArgs: undefined,
            messageType: 'ERROR',
            messageDatas: undefined,
            typeDialog: 'alertWks',
            actionCur: 'searchListPartsKO',
            progressDeterminate: false,
          };
        } else {
          messageDisplay = {
            titleBox: this._translateService.instant('searchListPartsTitle'),
            messageLabel: this._translateService.instant('selection_search_KO2', [err.status.toString(), inputValue]),
            messageArgs: undefined,
            messageType: 'ERROR',
            messageDatas: undefined,
            typeDialog: 'alertWks',
            actionCur: 'searchListPartsKO',
            progressDeterminate: false,
          };
        }
        this.displayMessageBox(messageDisplay.titleBox, messageDisplay.messageLabel, messageDisplay.messageType, messageDisplay.typeDialog, messageDisplay.actionCur, undefined);
      }
    );

  }
  affectResponseSearchReferential(paramPartsSuppliesList: ParamPartsSuppliesModel[], idxRow: number): void {
    
    for (const productItem of paramPartsSuppliesList) {
      const langLabels = productItem.langLabels;
      if (langLabels === null) {
        continue;
      }
      for (const langCur of langLabels) {
        if (langCur === null) {
          continue;
        }
        if (langCur.labelLang === this._userService.getUserLogged().userlang) {
          productItem.paramLabel = langCur.labelText;
          break;
        }
      }
      if (productItem.paramLabel === undefined) {
        productItem.paramLabel = productItem.langLabels[0].labelText;
      }
      const jsonData = JSON.parse(productItem.otherData);
      let supplierPackaging = 1;
      if (jsonData !== null && jsonData !== undefined) {
        if (jsonData.supplierPackaging !== undefined ) {
          supplierPackaging = Number(jsonData.supplierPackaging);
          if (supplierPackaging === 0) {
            supplierPackaging = 1;
          }
        }
      }
      this.rowsPartsFa.at(idxRow).get('brandRefFc').setValue(productItem.brandRef);
      this.rowsPartsFa.at(idxRow).get('brandLabelFc').setValue(productItem.paramLabel);
      this.rowsPartsFa.at(idxRow).get('supplierPackagingFc').setValue(supplierPackaging);
      this.rowsParts[idxRow].partsSupplies = productItem;
      this.rowsParts[idxRow].supplierPackaging = supplierPackaging;
      this.readStockByRef(productItem.brandRef, idxRow);
      break;
    }
  }
  // end read by barcode
  updateBarcodes(): void {

    for (let idxRow = 0 ; idxRow < this.rowsParts.length; idxRow++) {
      if (this.rowsParts[idxRow].barcode !== undefined 
        && this.rowsParts[idxRow].barcode !== null 
        && this.rowsParts[idxRow].barcode !== '') {
          this.updateBarcodeStockProduct(idxRow);
          this.updateBarcodeReferential(idxRow);
        }
    }
  }
  updateBarcodeStockProduct(idxRow: number): void {

    const apiService = 'update';
    const apiName = 'stockManagement';
    const toolApiName = this.wksApisService.stockManagementApi.toolName;

    const toolArgs: ToolArgs = {
      toolDatas: []
    };
    let testData = {
      key: 'toolCustomerNwsCode',
      value: this.wksApisService.getApiStockManagement().toolCustomerNwsCode
    };
    toolArgs.toolDatas.push(testData);
    testData = {
      key: 'toolCustomerNwsId',
      value: this.wksApisService.getApiStockManagement().toolCustomerNwsId
    };
    toolArgs.toolDatas.push(testData);

    let toolKeyValue: ToolKeyValue;
    toolKeyValue = {
      key: 'nws_stock_id',
      value: this.rowsParts[idxRow].stockId,
      listValues: undefined,
      arrayValues: undefined
    };
    let jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);

    toolKeyValue = {
      key: 'nws_label',
      value: this.rowsParts[idxRow].brandLabel,
      listValues: undefined,
      arrayValues: undefined
    };
    jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);

    let nwsBarcodeTypeSelected;
    const barcodeRef: BarCode = this._wksCentralService.getBarcodeRef(this.rowsParts[idxRow].barcode);

    if (barcodeRef !== undefined) {
      for (const toolApiNameCur of barcodeRef.APIS) {
        if (toolApiNameCur.apiName === toolApiName) {
          nwsBarcodeTypeSelected  = toolApiNameCur.nwsBarcodeType;
          break;
        }
      }
      if (nwsBarcodeTypeSelected !== undefined) {
        toolKeyValue = {
          key: 'nws_barcodeType',
          value: '' + nwsBarcodeTypeSelected ,
          listValues: undefined,
          arrayValues: undefined
        };
        jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
        toolArgs.toolDatas.push(jsonTmp);
      }
    }

    toolKeyValue = {
      key: 'nws_barcode',
      value: this.rowsParts[idxRow].barcode,
      listValues: undefined,
      arrayValues: undefined
    };
    jsonTmp = JSON.parse(JSON.stringify(toolKeyValue));
    toolArgs.toolDatas.push(jsonTmp);

    this.wksApisService.requestApis(this.wksEntity.stdEntity, apiName, apiService, toolArgs )
    .subscribe(
      (data: any) => {
        const toolApiResponse = data.body as ToolApiResponse;
        const jsonResponse = JSON.stringify(toolApiResponse);
        // console.log(jsonResponse);
        if (toolApiResponse.statut === 'KO') {

        } else  {
          const nwsId =  toolApiResponse.toolDatas[0].value;
        }
      },
      (err: any) => {
        const jsonResponse = JSON.stringify(err);
        console.log('Errot ' + jsonResponse);
      }
    );

  }
  updateBarcodeReferential(idxRow: number): void {
    const paramPartsSupplies = this.rowsParts[idxRow].partsSupplies;
    paramPartsSupplies.brandBarcode = this.rowsParts[idxRow].barcode;
    // paramPartsSupplies.barcode = this.rowsParts[idxRow].barcode;
    this._wksCentralService.saveParamPartSupplie(paramPartsSupplies, 'update')
    .subscribe(
      (data: any) => {

      },
      (err: any) => {
        console.log('update product error' + JSON.stringify(err));
      }
    );
  }
  triggerAlert(data: string, msgKey: string) {
    let  labelAlert = this._translateService.instant(msgKey);
    labelAlert = data + ' --> ' + labelAlert;
    this.alertMessage = labelAlert;
    this.showAlert = true;

    // auto-hide après 6 secondes
    setTimeout(() => this.showAlert = false, 6000);
  }

  closeAlert() {
    this.showAlert = false;
  }

  displayMessageBox(_titleBox: string, _messageBox: string, _messageType: string, _typeDialog: string, _actionCur: string, dataCur: any): void {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      id: 1,
      title: _titleBox,
      typeDialog: _typeDialog,
      panelClass: 'stdTheme',
      contentMessage: _messageBox,
      data1: '',
      data2: '',
      messageType: _messageType

      };

    const dialogRef = this._dialog.open(ModalCommonComponent, dialogConfig);

    dialogRef.afterClosed()
    .pipe(takeUntil(this.onDestroy))
    .subscribe(
      data => {
        // console.log('Dialog output:', data);
        if (( data === 'okAction') && _actionCur === 'readingDeliveries') {
            this.loadingIndicator = false;
        }
        if (( data === 'okAction') && _actionCur === 'readingDeliveryDetail') {
           
        }
        // searchListPartsKO
        if (( data === 'okAction') && _actionCur === 'searchListPartsKO') {
           
        }
      });

  }
  closeMatDialog(): void {
    this._dialog.closeAll();
    try  {
      // console.log(this._dialog.openDialogs.length);
      if (this._dialog.openDialogs.length > 0) {

        for (const instCur of this._dialog.openDialogs) {
          this._dialog.openDialogs.splice(0, 1);
        }
      }
    } catch (err) {}
    
  }
}
